import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import getHostScheduleDetail from 'Api/host/getHostScheduleDetail';

import getHostScheduleDetailResponse from './model/response/getHostScheduleDetailResponse';

const useGetHostScheduleDetail = () => {
  const { id } = useParams();

  return useQuery({
    queryKey: ['host-schedule-detail', id],
    queryFn: async () => {
      const response = await getHostScheduleDetail(id);

      const result = getHostScheduleDetailResponse(response);

      return result;
    },
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    retry: false,
    gcTime: 0,
  });
};

export default useGetHostScheduleDetail;
